<template lang="pug">
  el-dialog(:title="!dataForm.id ? '新增' : '修改'", :close-on-click-modal='false', :visible.sync='visible' :modal-append-to-body='false')
    el-form(:model='dataForm', :rules='dataRule', ref='dataForm', label-width='80px')
      el-form-item(label='角色名称', prop='roleName')
        el-input(v-model='dataForm.roleName', placeholder='角色名称')
      el-form-item(label='角色描述', prop='remark')
        el-input(v-model='dataForm.remark', placeholder='角色描述')
      el-form-item(size='mini', label='授权')
        el-tree(:data='menuList', :props='menuListTreeProps', node-key='menuId', ref='menuListTree', :default-expand-all='true', show-checkbox='')
    span.dialog-footer(slot='footer')
      el-button(@click='visible = false') 取消
      el-button(type='primary', @click='dataFormSubmit()' :disabled="clickFlag") 确定
</template>

<script>
import { treeDataTranslate } from '@/util'
export default {
  data () {
    return {
        clickFlag: false,
      visible: false,
      menuList: [],
      menuListTreeProps: {
        label: 'name',
        children: 'children'
      },
      dataForm: {
        id: 0,
        roleName: '',
        remark: ''
      },
      dataRule: {
        roleName: [
          { required: true, message: '角色名称不能为空！', trigger: 'blur' }
        ]
      },
      tempKey: -666666 // 临时key, 用于解决tree半选中状态项不能传给后台接口问题. # 待优化
    }
  },
  methods: {
    init (id) {
        this.clickFlag = false
      this.dataForm.id = id || 0
      this.$http({
        url: this.$http.adornUrl('/sys/menu/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then((data) => {
        this.menuList = treeDataTranslate(data, 'menuId')
      }).then(() => {
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          this.$refs.menuListTree.setCheckedKeys([6])
        })
      }).then(() => {
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`/sys/role/info/${this.dataForm.id}`),
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            if (data && data.code === 0) {
              this.dataForm.roleName = data.role.roleName
              this.dataForm.remark = data.role.remark
              var idx = data.role.menuIdList.indexOf(this.tempKey)
              if (idx !== -1) {
                data.role.menuIdList.splice(idx, data.role.menuIdList.length - idx)
              }
              this.$refs.menuListTree.setCheckedKeys(data.role.menuIdList)
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
            this.clickFlag = true
          this.$http({
            url: this.$http.adornUrl(`/sys/role/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: {
              'roleId': this.dataForm.id || undefined,
              'roleName': this.dataForm.roleName,
              'remark': this.dataForm.remark,
              'menuIdList': [].concat(this.$refs.menuListTree.getCheckedKeys(), [this.tempKey], this.$refs.menuListTree.getHalfCheckedKeys())
            }
          }).then((data) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshdatalist')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>
